var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEc = function SvgIconEc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12l-12 1.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M1.605 18C3.68 21.589 7.558 24 12 24s8.319-2.412 10.394-6L12 17.219z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M22.394 18A11.94 11.94 0 0 0 24 12H0c0 2.186.585 4.235 1.606 6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 16.174a4.174 4.174 0 1 0 0-8.347 4.174 4.174 0 0 0 0 8.347"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M12 14.61A2.61 2.61 0 0 1 9.392 12v-1.565A2.61 2.61 0 0 1 12 7.827a2.61 2.61 0 0 1 2.609 2.608v1.566A2.61 2.61 0 0 1 12 14.609"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.174 5.74h-3.13a1.044 1.044 0 0 0-2.087 0h-3.13c0 .576.501 1.043 1.077 1.043H8.87c0 .577.467 1.044 1.043 1.044 0 .576.467 1.043 1.044 1.043h2.087c.576 0 1.043-.467 1.043-1.043.576 0 1.044-.467 1.044-1.043h-.035c.576 0 1.078-.468 1.078-1.044"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconEc;